<template>
  <div id="camera">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>监控管理&nbsp;/&nbsp;摄像头管理</span>
        </div>
        <div class="camera_top" style="">
          <!-- <Provinces @gain='gainSS'></Provinces> -->
          <Week @childFn="parentFn"></Week>
         <el-input class="elinputs" v-model="beginData.name" placeholder="请输入办宴点名称"></el-input>
         <el-select v-model="beginData.brand" placeholder="摄像头品牌" class="elinputs">
              <el-option v-for="item in beginData.cameraBrandArray" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
          </el-select>
          <el-select v-model="beginData.status" placeholder="状态" class="elinputs">
              <el-option v-for="item in beginData.statuss" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
          </el-select>
          <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
          <el-button type="info" @click="resets">重置</el-button>
        </div>
        <div class="tit">
          <Reset @clkBtn='theBtn'></Reset>
          <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="position" label="摄像头位置" min-width="130"></el-table-column>
            <el-table-column prop="banquetPointName" label="办宴点" width="180"></el-table-column>
            <el-table-column prop="areasName" label="地址" min-width="260"></el-table-column>
            <el-table-column label="摄像头品牌" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.brand == 1" style="color:#F56C6C">大华</p>
                    <p class="boldfont" v-else style="color:#67C23A">海康</p>
                </template>
            </el-table-column>
            <el-table-column label="摄像头预览" width="180">
                <template slot-scope="scope">
                    <img class="sfzimg" :src="scope.row.coverUrl" @click="lookvid(scope.row)"/>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.status" style="color:#F56C6C">禁用</p>
                    <p class="boldfont" v-else style="color:#67C23A">启用</p>
                </template>
            </el-table-column>
            <el-table-column prop="addTime" sortable label="创建时间" width="180"></el-table-column>
            <el-table-column prop="updateTime" sortable label="更新时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'camera:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'camera:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="添加/编辑摄像头" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 办宴点：">
                <el-select v-model="mydata.banquetPointId" placeholder="办宴点选择">
                    <el-option v-for="item in cidList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 位 置：">
               <el-input placeholder="摄像头位置描述" v-model="mydata.position" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 摄像头品牌：">
                <el-radio v-model="mydata.brand" label=1>大华</el-radio>
                <el-radio v-model="mydata.brand" label=2>海康</el-radio>
            </el-form-item>
            <el-form-item label="* 摄像头链接：">
               <el-input placeholder="请输入摄像头链接" v-model="mydata.liveUrl" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 封面链接：">
               <el-input placeholder="请输入封面链接" v-model="mydata.coverUrl" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 状 态：">
                <el-radio v-model="mydata.status" label=0>启用</el-radio>
                <el-radio v-model="mydata.status" label=1>禁用</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="puton(2)">确 定</el-button>
        </div>
    </el-dialog>
    <el-drawer title="摄像头预览" :visible.sync="drawer" direction="ltr" size="50%">
        <div class="cam_dra_top">
          <p class="cam_vid"><span>摄像头地址：{{draData.areasName}}</span></p>
          <p class="cam_vid"><span>办宴点：{{draData.banquetPointName}}</span><span>摄像头位置：{{draData.position}}</span></p>
        </div>
        <div style="width:90%;margin: 2% auto 4%;height:560px"><p id="playercontainer"></p></div>
    </el-drawer>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import Week from '@/components/Week'
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "camera",
  components: {
    Xlsx,
    EditorBar,
    Week,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{statuss:[{name:'启用',id:0},{name:'禁用',id:1}], cameraBrandArray:[{name:'大华',id:1},{name:'海康',id:2}]},
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname:JSON.stringify({name:'摄像头管理',hint:'camera:export'}),
        cidList:[],
        mydata:{status:'0', brand:'1'},
        multipleSelection:[],
        drawer:false,
        draData:{}
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('camera:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('camera:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('camera:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 权限按钮
    opbtn(i){
        if(this.btn.indexOf(i)==-1){
            return false
        }else{
            return true
        }
    },
    // 获取省市传入的id
    // gainSS(i){
    //     this.beginData.areaId = i.id
    // },
    parentFn(i){
        this.beginData.areaId = i.id
    },
    // 监控查看
    lookvid(row){
      const _this = this
      _this.drawer = true
      _this.draData = row
      this.$nextTick(()=>{
        _this.player = cyberplayer("playercontainer").setup({
            width: "100%", // 宽度，也可以支持百分比（不过父元素宽度要有）
            height: "100%", // 高度，也可以支持百分比
            title: row.position, // 标题
            isLive: true, // 必须设置，表明是直播视频
            file: row.liveUrl, // //您的视频源的地址（目前是乐橙示例播放地址）
            image: row.coverUrl, // 预览图
            autostart: false, // 是否自动播放
            stretching: "uniform", // 拉伸设置
            repeat: false, // 是否重复播放
            volume: 0, // 音量，注：仅当用户同意、网站由用户激活或媒体无声时允许自动播放
            controls: true, // 是否显示控制栏
            hls: {
                reconnecttime: 5 // hls直播重连间隔秒数
            },
            ak: "39f82ac87fc3462ea4dcc78734450f57" // 百度智能云平台注册（https://cloud.baidu.com）即可获得accessKey
        });
      })
    },
    // 查询所有办宴点
    ownby(){
        this.$axios.post(`/api-r/banquetPoint/getAllBanquetPointList/${this.userdata.areasId}`,{}, {headers: { accessToken: this.userdata.token }})
        .then(res => {
            if(res.data.success){
                this.cidList = res.data.banquetPointInfoList
            }
        });
    },
    // 修改办宴点
    again(){
      this.mydata.modify = 2
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-r/banquetPoint/deleteCamera/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
      this.mydata={status:'0', brand:'1'}
      this.begin()
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(!this.mydata.banquetPointId||!this.mydata.coverUrl||!this.mydata.liveUrl||!this.mydata.position||!this.mydata.brand){
            this.$message('请完善必填信息')
            return
        }
        // 判断是点击哪个
        this.fullscreenLoading = true;
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-r/banquetPoint/addCamera`
        }else if(this.mydata.stat==1){
            url = `/api-r/banquetPoint/updateCamera`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.begin()
                this.dialogFormVisible = false
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaId:this.beginData.areaId,
        name:this.beginData.name,
        status:this.beginData.status,
        brand:this.beginData.brand,
        adminAreasId:userdata.areasId
      });
      this.$axios.post(`/api-r/banquetPoint/getCameraList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        this.ownby()
        sessionStorage.setItem('xgStat',0)
        if(i == 0){
            this.mydata.stat = i
            this.mydata.modify = i
        }else if(i == 1){
            let obj = JSON.parse(JSON.stringify(row));
            obj.stat = i
            if(obj.status){
              obj.status = '1'
            }else{
              obj.status = '0'
            }
            if(obj.brand == 1) {
              obj.brand = '1'
            } else {
              obj.brand = '2'
            }
            obj.modify = i
            this.mydata = obj
        }
        this.dialogFormVisible = true
    },
    // 删除摄像头
    stop(row,hint) {
      if(hint&&this.btn.indexOf(hint)==-1){
          return this.$message('抱歉，用户暂无该权限')
      }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-r/banquetPoint/deleteCamera/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  },
  beforeDestroy() {
    if(this.player!=undefined){
      this.player.remove();
    }
  },
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
.cam_vid{
    width: 90%;
    margin: 0 auto;
    display: flex;
}
.cam_dra_top{
    line-height: 38px;
}
.cam_dra_top>.cam_vid:last-child>span:first-child{
  width: 50%
}
#camera .el-input__inner {
  margin: 10px 0;
}
#camera .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#camera .el-menu-item.is-active{
  background: none
}
#camera .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#camera .el-tag{
  margin-right: 12px;
}
#camera .el-select {
  /* margin: 0 8px; */
  width: 100%;
}
#camera .camera_top{
  display: flex;flex-wrap: wrap;align-items: center;
}
#camera .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#camera .el-upload-list--picture .el-upload-list__item {
    /* float: left;
    margin-right: 2%; */
}
#camera .el-form-item__content {
    display: flex;
    flex-wrap: wrap;
    width: 80%
}
#camera .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#camera .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#camera .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#camera .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#camera .el-dialog__body {
  height: 100%;
}
#camera .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#camera .el-form-item__label{
    width: 120px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
.again{
  color: red;
  margin-left: 16px;
  text-decoration: underline;
  cursor: pointer;

}
</style>
